var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6950_4207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.36773 23.6951H5.18708C3.94837 23.6951 2.8645 22.6887 2.8645 21.3726V11.5403C2.8645 11.0758 3.17418 10.7661 3.6387 10.7661C4.10321 10.7661 4.41289 11.0758 4.41289 11.5403V21.45C4.41289 21.8371 4.72257 22.2242 5.18708 22.2242H9.36773C9.83224 22.2242 10.1419 22.5339 10.1419 22.9984C10.1419 23.4629 9.83224 23.6951 9.36773 23.6951Z",
    fill: "#79C8B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36773 23.6951H5.18708C3.94837 23.6951 2.8645 22.6887 2.8645 21.3726V11.5403C2.8645 11.0758 3.17418 10.7661 3.6387 10.7661C4.10321 10.7661 4.41289 11.0758 4.41289 11.5403V21.45C4.41289 21.8371 4.72257 22.2242 5.18708 22.2242H9.36773C9.83224 22.2242 10.1419 22.5339 10.1419 22.9984C10.1419 23.4629 9.83224 23.6951 9.36773 23.6951Z",
    fill: "url(#paint0_linear_6950_4207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0386 23.6951H13.4709C11.9999 23.6951 10.8386 22.5339 10.8386 21.0629V18.8177C10.8386 18.3532 11.1483 18.0435 11.6128 18.0435C12.0773 18.0435 12.387 18.3532 12.387 18.8177V21.0629C12.387 21.6822 12.8515 22.1468 13.4709 22.1468H18.0386C18.4257 22.1468 18.8128 21.8371 18.8128 21.3726V11.5403C18.8128 11.0758 19.1225 10.7661 19.587 10.7661C20.0515 10.7661 20.3612 11.0758 20.3612 11.5403V21.45C20.3612 22.6887 19.3548 23.6951 18.0386 23.6951Z",
    fill: "#79C8B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0386 23.6951H13.4709C11.9999 23.6951 10.8386 22.5339 10.8386 21.0629V18.8177C10.8386 18.3532 11.1483 18.0435 11.6128 18.0435C12.0773 18.0435 12.387 18.3532 12.387 18.8177V21.0629C12.387 21.6822 12.8515 22.1468 13.4709 22.1468H18.0386C18.4257 22.1468 18.8128 21.8371 18.8128 21.3726V11.5403C18.8128 11.0758 19.1225 10.7661 19.587 10.7661C20.0515 10.7661 20.3612 11.0758 20.3612 11.5403V21.45C20.3612 22.6887 19.3548 23.6951 18.0386 23.6951Z",
    fill: "url(#paint1_linear_6950_4207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7547 11.6955H1.47085C0.696656 11.6955 0.30956 10.689 0.928914 10.2245L11.0709 1.70837C11.3805 1.47612 11.845 1.47612 12.1547 1.70837L22.2967 10.1471C22.916 10.689 22.5289 11.6955 21.7547 11.6955Z",
    fill: "#79C8B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7547 11.6955H1.47085C0.696656 11.6955 0.30956 10.689 0.928914 10.2245L11.0709 1.70837C11.3805 1.47612 11.845 1.47612 12.1547 1.70837L22.2967 10.1471C22.916 10.689 22.5289 11.6955 21.7547 11.6955Z",
    fill: "url(#paint2_linear_6950_4207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2968 15.4117C9.98714 15.4117 9.75488 15.1794 9.75488 14.8697V13.0117C9.75488 12.702 9.98714 12.4697 10.2968 12.4697C10.6065 12.4697 10.8388 12.702 10.8388 13.0117V14.8697C10.7613 15.2568 10.5291 15.4117 10.2968 15.4117Z",
    fill: "#79C8B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2968 15.4117C9.98714 15.4117 9.75488 15.1794 9.75488 14.8697V13.0117C9.75488 12.702 9.98714 12.4697 10.2968 12.4697C10.6065 12.4697 10.8388 12.702 10.8388 13.0117V14.8697C10.7613 15.2568 10.5291 15.4117 10.2968 15.4117Z",
    fill: "url(#paint3_linear_6950_4207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9291 15.4117C12.6195 15.4117 12.3872 15.1794 12.3872 14.8697V13.0117C12.3872 12.702 12.6195 12.4697 12.9291 12.4697C13.2388 12.4697 13.4711 12.702 13.4711 13.0117V14.8697C13.4711 15.2568 13.2388 15.4117 12.9291 15.4117Z",
    fill: "#79C8B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9291 15.4117C12.6195 15.4117 12.3872 15.1794 12.3872 14.8697V13.0117C12.3872 12.702 12.6195 12.4697 12.9291 12.4697C13.2388 12.4697 13.4711 12.702 13.4711 13.0117V14.8697C13.4711 15.2568 13.2388 15.4117 12.9291 15.4117Z",
    fill: "url(#paint4_linear_6950_4207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.613 20.3664C10.0646 20.3664 8.82593 19.1277 8.82593 17.5793V15.8761C8.82593 15.3341 9.29044 14.8696 9.83238 14.8696H13.3163C13.8582 14.8696 14.3227 15.3341 14.3227 15.8761V17.5793C14.4001 19.1277 13.1614 20.3664 11.613 20.3664Z",
    fill: "#79C8B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.613 20.3664C10.0646 20.3664 8.82593 19.1277 8.82593 17.5793V15.8761C8.82593 15.3341 9.29044 14.8696 9.83238 14.8696H13.3163C13.8582 14.8696 14.3227 15.3341 14.3227 15.8761V17.5793C14.4001 19.1277 13.1614 20.3664 11.613 20.3664Z",
    fill: "url(#paint5_linear_6950_4207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5421 17.4247L11.8453 17.0377L12.3098 15.7989C12.3098 15.7215 12.2324 15.6441 12.155 15.7215L10.6066 17.0377C10.4518 17.1925 10.5292 17.4247 10.684 17.5022L11.4582 17.9667L10.9937 19.128C10.9937 19.2054 11.0711 19.2828 11.1486 19.2054L12.6969 17.8893C12.6969 17.7344 12.6969 17.5796 12.5421 17.4247Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6950_4207",
    x1: 2.95114,
    y1: 16.1532,
    x2: 10.2654,
    y2: 16.1952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA37C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FA37C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6950_4207",
    x1: 10.952,
    y1: 16.1532,
    x2: 20.5226,
    y2: 16.2251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA37C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FA37C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6950_4207",
    x1: 0.883516,
    y1: 5.76805,
    x2: 22.9668,
    y2: 6.25553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA37C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FA37C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6950_4207",
    x1: 9.76779,
    y1: 13.6955,
    x2: 10.8572,
    y2: 13.6996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA37C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FA37C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6950_4207",
    x1: 12.4001,
    y1: 13.6955,
    x2: 13.4895,
    y2: 13.6996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA37C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FA37C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6950_4207",
    x1: 8.89141,
    y1: 17.16,
    x2: 14.4191,
    y2: 17.2164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA37C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FA37C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6950_4207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.2258,
    height: 24,
    fill: "white",
    transform: "translate(0 0.39209)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevice);
export default __webpack_public_path__ + "static/media/device.90612edda0687c82522475f36c8c525d.svg";
export { ForwardRef as ReactComponent };